<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->

<ng-container *ngIf="editForm && activeLayerIndex !== undefined">
    <form [formGroup]="editForm" [windeDisableFormControls]="viewInReadOnly ? editForm : null" class="clr" name="editForm">
        <h5 class="mb-3">Select Products</h5>

        <table aria-describedby="mydesc" class="table device-table">
            <thead>
                <tr style="display: none">
                    <th class="td--below">Below Distance</th>
                    <th class="td--distance">Distance</th>
                    <th class="td--use">Use</th>
                    <th class="td--product">Product</th>
                    <th class="td--antenna">Antenna</th>
                    <th class="td--and"></th>
                    <th class="td--product">Product TU</th>
                    <th class="td--antenna">Antenna TU</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody formArrayName="productsToUse" id="productsToUse">
                @for (product of productsToUseArr.controls; let prodIndex = $index; track product) {
                    <tr [formGroupName]="'' + prodIndex" [id]="'productsRow_' + prodIndex">
                        <td class="td--warning">
                            @if (pairMayCorruptFrozenLinks(product)) {
                                <sui-svg-icon
                                        class="status-icon-warning"
                                        icon="exclamation-triangle"
                                        windeGrey
                                        suiTooltip
                                        position="top"
                                        tooltipText="{{ 'project.frozenLinksForProductPairExistWarning' | translate }}"
                                />
                            }
                        </td>
                        <td class="td--below">
                            <span> Below distance </span>
                        </td>
                        <td class="td--distance">
                            <input
                                    (change)="validateProducts()"
                                    (input)="needHideNoneProductRow(prodIndex)"
                                    [required]="product.get('usedProd').value !== null && product.get('usedProd').value > -1"
                                    class="form-control form-control-sm"
                                    formControlName="threshold"
                                    id="threshold_{{ prodIndex }}_{{ activeLayerIndex }}"
                                    step="1"
                                    type="number"
                            />
                        </td>
                        <td class="td--use">
                            <span *ngIf="prodIndex === 0"> use </span>
                            <span *ngIf="prodIndex > 0">
                                and above {{ productsToUseArr.controls[prodIndex - 1].get('threshold').value }} use
                            </span>
                        </td>
                        <td class="td--product">
                            <select
                                    (change)="onChangeUsedProduct(prodIndex)"
                                    class="form-control form-control-sm"
                                    formControlName="usedProd"
                                    id="usedProd_{{ prodIndex }}_{{ activeLayerIndex }}"
                            >
                                <option *ngIf="prodIndex > 0" [ngValue]="null">none</option>
                                <option *ngFor="let productItem of usedProduct" [ngValue]="productItem.id">
                                    {{ productItem.name === 'MultiHaul' ? 'MH-BU' : productItem.name }}
                                </option>
                            </select>
                        </td>
                        <td class="td--antenna">
                            <select
                                    *ngIf="product.get('usedProd').value !== null"
                                    class="form-control form-control-sm"
                                    formControlName="usedAnt0"
                                    id="usedAnt0_{{ prodIndex }}_{{ activeLayerIndex }}"
                            >
                                <option
                                        *ngFor="let antennaItem of availableAntennas[product.get('usedProd').value]"
                                        [ngValue]="antennaItem.id"
                                >
                                    {{ antennaItem.name }}
                                </option>
                            </select>
                        </td>
                        <td class="td--and">
                            @if (hasToShowTUProduct(product.get('usedProd').value)) {
                                <span>and {{ getProductName(product.get('usedProd').value) }} or</span>
                            }
                        </td>
                        <td class="td--product">
                            <select
                                    (change)="onChangeTuProduct(prodIndex)"
                                    *ngIf="hasToShowTUProduct(product.get('usedProd').value)"
                                    class="form-control form-control-sm"
                                    formControlName="usedProdTU"
                                    id="usedProdTU_{{ prodIndex }}_{{ activeLayerIndex }}"
                            >
                                <option *ngFor="let productItem of usedProductTu[product.get('usedProd').value]" [ngValue]="productItem.id">
                                    {{ productItem.name === 'MultiHaul' ? 'MH-BU' : productItem.name }}
                                </option>
                            </select>
                        </td>
                        <td class="td--antenna">
                            <select
                                    *ngIf="hasToShowTUProduct(product.get('usedProd').value)"
                                    class="form-control form-control-sm"
                                    formControlName="usedAnt1"
                                    id="usedAnt1_{{ prodIndex }}_{{ activeLayerIndex }}"
                            >
                                <option
                                        *ngFor="let antennaItem of availableAntennas[product.get('usedProdTU').value]"
                                        [ngValue]="antennaItem.id"
                                >
                                    {{ antennaItem.name }}
                                </option>
                            </select>
                        </td>
                        @if (!viewInReadOnly) {
                            <td class="td--button">
                                <winde-ctx-sensitive-help
                                        tooltipTextPath="project.createOrEditDialog.btn.addChannelBandwidth">
                                    <button (click)="onInsertUsedProduct(product)" windeActionIcon>
                                        <sui-svg-icon icon="plus-circle" windeGreen/>
                                    </button>
                                </winde-ctx-sensitive-help>
                            </td>
                            <td class="td--button">
                                <winde-ctx-sensitive-help
                                        *ngIf="product.get('usedProd').value !== null"
                                        id="editChannelBandwidth"
                                        tooltipTextPath="project.createOrEditDialog.btn.editChannelBandwidth"
                                >
                                    <button (click)="editProductConfig(product.get('usedProd').value, prodIndex)" windeActionIcon>
                                        <sui-svg-icon icon="pencil" windeOrange/>
                                    </button>
                                </winde-ctx-sensitive-help>
                            </td>
                            <td class="td--button">
                                <winde-ctx-sensitive-help
                                        id="removeChannelBandwidth"
                                        tooltipTextPath="project.createOrEditDialog.btn.removeChannelBandwidth"
                                >
                                    <button (click)="onRemoveUsedProduct(product)" windeActionIcon>
                                        <sui-svg-icon icon="cross" windeRed/>
                                    </button>
                                </winde-ctx-sensitive-help>
                            </td>
                        }
                    </tr>
                }
                @if (!viewInReadOnly && !needHideNoneProduct) {
                    <tr [formGroup]="noneProductConfig">
                        <td class="td--warning"></td>
                        <td class="td--below"></td>
                        <td class="td--distance"></td>
                        <td class="td--use"></td>
                        <td class="td--product">
                            <select (change)="onAddUsedProduct()" class="form-control form-control-sm" formControlName="usedProd">
                                <option [ngValue]="null">none</option>
                                <option *ngFor="let productItem of usedProduct" [ngValue]="productItem.id">
                                    {{ productItem.name === 'MultiHaul' ? 'MH-BU' : productItem.name }}
                                </option>
                            </select>
                        </td>
                        <td></td>
                        <td></td>
                    </tr>
                }
            </tbody>
        </table>

        <div *ngIf="hasMhProduct" class="row" formGroupName="defaultMHProducts">
            <div class="form-group col-6">
                <label class="form-control-label" for="defaultBu_{{ activeLayerIndex }}">{{ 'project.defaultBuRadio' | translate }}</label>
                <div class="d-flex align-items-center">
                    <select
                            class="form-control form-control-sm"
                            formControlName="defaultBuProductPerLayer"
                            id="defaultBu_{{ activeLayerIndex }}"
                    >
                        <option *ngFor="let buRadio of dialogProductsService.availableBu" [ngValue]="buRadio.key">
                            {{ buRadio.value }}
                        </option>
                    </select>
                    <winde-ctx-sensitive-help placement="bottom" tooltipTextPath="productRadioName.btn.openProductPage">
                        <div [isUseInfoButton]="true" [outerLink]="getDefaultBuLink()" class="ml-2 my-auto" windeProductNameLink></div>
                    </winde-ctx-sensitive-help>
                </div>
            </div>
            <div class="form-group col-6">
                <label class="form-control-label" for="defaultTu_{{ activeLayerIndex }}">{{ 'project.defaultTuRadio' | translate }}</label>
                <div class="d-flex align-items-center">
                    <select
                            class="form-control form-control-sm"
                            formControlName="defaultTuProductPerLayer"
                            id="defaultTu_{{ activeLayerIndex }}"
                    >
                        <option *ngFor="let tuRadio of dialogProductsService.availableTu" [ngValue]="tuRadio.key">
                            {{ tuRadio.value }}
                        </option>
                    </select>
                    <winde-ctx-sensitive-help placement="bottom" tooltipTextPath="productRadioName.btn.openProductPage">
                        <div [isUseInfoButton]="true" [outerLink]="getDefaultTuLink()" class="ml-2 my-auto" windeProductNameLink></div>
                    </winde-ctx-sensitive-help>
                </div>
            </div>
        </div>
    </form>

    @if (isShowRadioConfig && selectedProductsPerLayer && selectedEngineRadio) {
        <winde-product-radio-config
                (isModifiedRadioList)="isModifiedRadioList($event)"
                (isValidChange)="checkFrequenciesValidation($event)"
                [configLevel]="configLevel.PROJECT"
                [currentEngineRadio]="selectedEngineRadio"
                [customerId]="customerId"
                [pairToEngineRadio]="selectedPairToEngineRadio"
        ></winde-product-radio-config>
    }
</ng-container>
